import Route from '@ember/routing/route';
import type { ReimaginedContributionHistoryModel } from 'tio-employee/components/reimagined/production/contribution-history';

export default class AuthenticatedSlrPaymentHistoryRoute extends Route {
  model() {
    const dashboardModel = this.modelFor('authenticated.slr.dashboard') as
      | { reimagined: ReimaginedContributionHistoryModel }
      | undefined;
    return dashboardModel?.reimagined?.contributionHistory;
  }
}
